import { render } from "./ServiceCategoryDisplay.vue?vue&type=template&id=58d4626a"
import script from "./ServiceCategoryDisplay.vue?vue&type=script&lang=js"
export * from "./ServiceCategoryDisplay.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__